<template>
  <div class="row">
    <div class="col-4">
      <div class="row card">
        <img v-bind:src="userProfile.image" class="center" />
        <p class="nameCls">
          {{
            `${this.user.firstName} ${
              this.user.lastName != undefined ? this.user.lastName : ""
            }`
          }}
        </p>
        <nav id="sidebar">
          <!-- <ul>
            <i class="fa fa-home item" aria-hidden="true"></i>Overview
          </ul>-->
          <ul
            @click="navLink = 'account'"
            :class="navLink == 'account' ? 'activeItem' : ''"
          >
            <i class="fa fa-cog item" aria-hidden="true"></i
            >Account Settings
          </ul>
          <ul
            @click="navLink = 'help'"
            :class="navLink == 'help' ? 'activeItem' : ''"
          >
            <i class="fa fa-question-circle item" aria-hidden="true"></i
            >Help
          </ul>
        </nav>
      </div>
    </div>
    <div class="col-8">
      <div class="card" style="min-height: 450px">
        <div class="container-fluid pt-2">
          <b-tabs v-if="navLink == 'account'" content-class="mt-3">
            <b-tab @click="message = ''" title="General" active>
              <b-alert
                :show="message.length > 0 ? true : false"
                :variant="variant"
                dismissible
                @dismissed="message = ''"
                >{{ message }}</b-alert
              >
              <form @submit.prevent="saveProfile">
                <div class="row">
                  <div class="col-6">
                    <label>First Name</label>
                    <input
                      type="text"
                      required
                      v-model="userProfile.firstName"
                      @keyup="saveProfilekeyUp"
                      class="form-control"
                      placeholder="First Name"
                    />
                  </div>
                  <!--  @keyup="updateCheck=true" -->
                  <div class="col-6">
                    <label>Last Name</label>
                    <input
                      type="text"
                      required
                      class="form-control"
                      v-model="userProfile.lastName"
                      @keyup="saveProfilekeyUp"
                      placeholder="Last Name"
                    />
                  </div>
                </div>
                <div
                  v-if="userProfile.cognito && userProfile.cognito.id"
                  class="row"
                  style="margin: 1px"
                >
                  <label>Email</label>
                  <input
                    type="email"
                    class="form-control"
                    required
                    @keyup="
                      updateCheck =
                        userProfile.firstName &&
                        userProfile.firstName.length > 0 &&
                        userProfile.lastName &&
                        userProfile.lastName.length > 0 &&
                        userProfile.cognito.email &&
                        userProfile.cognito.email.length > 0
                          ? true
                          : false
                    "
                    v-model="userProfile.cognito.email"
                    placeholder="Email"
                  />
                </div>
                <!-- <div class="row" style="margin: 1px;">
                <label>About</label>
                <textarea class="form-control" v-model="userProfile.aboutMe" rows="5"></textarea>
                </div>-->
                <div class="row" style="margin: 1px">
                  <button
                    type="submit"
                    class="todo-form-submit-button btn btn-primary"
                    :disabled="submitted || !updateCheck"
                  >
                    Save
                    <b-spinner
                      v-if="submitted"
                      style="float: right"
                      small
                      label="Loading..."
                    ></b-spinner>
                  </button>
                </div>
              </form>
            </b-tab>
            <b-tab @click="message = ''" title="Single Sign on">
              <div class="row" style="margin: 1px">
                <p style="color: rgb(0, 0, 0); width: 26%">Linkedin</p>
                <p
                  style="cursor: pointer"
                  @click="Link('linkedin', linkedin)"
                  v-bind:class="
                    user.linkedin && user.linkedin.id
                      ? 'text-danger'
                      : 'text-info'
                  "
                >
                  {{ user.linkedin && user.linkedin.id ? "Unlink" : "Link" }}
                </p>
                <input
                  v-if="user.linkedin && user.linkedin.id"
                  disabled
                  style="margin-top: -1%"
                  v-model="user.linkedin.email"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="row" style="margin: 1px">
                <p style="color: rgb(0, 0, 0); width: 26%">Google</p>
                <p
                  style="cursor: pointer"
                  @click="Link('google', google)"
                  v-bind:class="
                    user.google && user.google.id ? 'text-danger' : 'text-info'
                  "
                >
                  {{ user.google && user.google.id ? "Unlink" : "Link" }}
                </p>
                <input
                  disabled
                  type="text"
                  style="margin-top: -1%"
                  v-if="user.google && user.google.id"
                  v-model="user.google.email"
                  class="form-control"
                />
              </div>
              <!-- <div class="row" style="margin: 1px;">
                <p style="color: rgb(0, 0, 0);width: 26%;">Facebook</p>
                <p
                  style="cursor: pointer;"
                  @click="Link('facebook',facebook)"
                  v-bind:class="(user.facebook && user.facebook.id)?'text-danger':'text-info'"
                >{{user.facebook && user.facebook.id ? "Unlink":"Link" }}</p>
                <input
                  v-if="user.facebook && user.facebook.id"
                  disabled
                  style="margin-top: -1%;"
                  v-model="user.facebook.email"
                  type="text"
                  class="form-control"
                />
              </div>-->
              <div class="row" style="margin: 1px">
                <p style="color: rgb(0, 0, 0); width: 26%">Twitter</p>
                <p
                  style="cursor: pointer"
                  @click="Link('twitter', twitter)"
                  v-bind:class="
                    user.twitter && user.twitter.id
                      ? 'text-danger'
                      : 'text-info'
                  "
                >
                  {{ user.twitter && user.twitter.id ? "Unlink" : "Link" }}
                </p>
                <input
                  v-if="user.twitter && user.twitter.id"
                  disabled
                  style="margin-top: -1%"
                  v-model="user.twitter.email"
                  type="text"
                  class="form-control"
                />
              </div>
            </b-tab>
            <b-tab
              @click="message = ''"
              v-if="userProfile.cognito && userProfile.cognito.id"
              title="Password"
            >
              <b-alert
                :show="message.length > 0 ? true : false"
                :variant="variant"
                dismissible
                @dismissed="message = ''"
                >{{ message }}</b-alert
              >
              <form @submit.prevent="changePswd">
                <div class="row" style="margin: 1px">
                  <label>Old Password</label>
                  <input
                    type="password"
                    class="form-control team-form"
                    v-model="pswd.oldPswd"
                    required
                    placeholder="Old Password"
                  />
                </div>
                <div class="row" style="margin: 1px">
                  <label>New Password</label>
                  <input
                    type="password"
                    v-model="pswd.newPswd"
                    class="form-control team-form"
                    required
                    @keyup="passwordValidation"
                    placeholder="New Password"
                  />
                </div>
                <div class="row" style="margin: 1px">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    v-model="pswd.cnfrmPswd"
                    required
                    class="form-control team-form"
                    placeholder="Confirm Password"
                  />
                </div>
                <small class="text-danger" v-if="!valid"
                  >Password must be minimum of 8 characters, it should be
                  alphanumeric and have at least one uppercase and one special
                  character.</small
                >
                <div class="row" style="margin: 1px">
                  <button
                    type="submit"
                    :disabled="submitted || !valid"
                    class="todo-form-submit-button btn btn-primary"
                  >
                    Submit
                    <b-spinner
                      v-if="submitted"
                      style="float: right"
                      small
                      label="Loading..."
                    ></b-spinner>
                  </button>
                </div>
              </form>
            </b-tab>
            <b-tab title="Privacy Settings">
              <h5 style="margin-left: 10px">
                Clear My Data permanently deletes all the workspaces and its
                data associated with this account.
              </h5>
              <button
                type="submit"
                @click="deleteFlag = true"
                class="btn btn-info btn-fill clear-my-data"
              >
                Clear My Data
                <!-- <b-spinner v-if="submitted" style="float: right;" small label="Loading..."></b-spinner> -->
              </button>
            </b-tab>
            <b-tab title="Email Preferences">
              <div class="row" style="margin: 1px 1px 10px 1px">
                <div style="margin-right: 5px" class="d-flex my-auto">
                  <input
                    type="checkbox"
                    id="dailyCheckbox"
                    v-model="dailyCheckbox"
                    class="regular-checkbox"
                    style="cursor: pointer"
                    @change="checkBoxChangeEvent($event)"
                  />
                </div>
                <div>Send emails Daily.</div>
              </div>
              <div class="row" style="margin: 1px 1px 10px 1px">
                <div style="margin-right: 5px" class="d-flex my-auto">
                  <input
                    type="checkbox"
                    id="weeklyCheckbox"
                    v-model="weeklyCheckbox"
                    class="regular-checkbox"
                    style="cursor: pointer"
                    @change="checkBoxChangeEvent($event)"
                  />
                </div>
                <div>Send emails Weekly.</div>
              </div>
              <div class="row" style="margin: 1px 1px 10px 1px">
                <div style="margin-right: 5px" class="d-flex my-auto">
                  <input
                    type="checkbox"
                    id="monthlyCheckbox"
                    v-model="monthlyCheckbox"
                    class="regular-checkbox"
                    style="cursor: pointer"
                    @change="checkBoxChangeEvent($event)"
                  />
                </div>
                <div>Send emails Monthly.</div>
              </div>
            </b-tab>
          </b-tabs>
          <div v-if="navLink == 'help'" style="margin-top: 29px">
            <p>
              Congratulations! You have instant access to fiifi, start using
              this software and give us feedback as it develops.
            </p>
            <p>
              <b>Note:</b> You have been granted early access, this product is
              not complete and will change further. If you are not excited to
              use fiifi in its current state, then please wait until the
              software progresses further in development to use
            </p>
            <p>
              Fiifi is already a robust tool for early stage investors, filled
              with features needed to make early stage investments, a registrar,
              charts, graphs and data for you to make more informed decisions.
            </p>
            <p>
              We designed fiifi for early access from the ground up, so you
              could help us make it even better by our first beta version
              launch.
            </p>
            <p>
              We are here to help! If you have questions, comments and
              especially feedback we would love to hear it.
            </p>
            <p>
              Please reach out to
              <a href="mailto: support@fiifi.co">support@fiifi.co</a>
            </p>
            <p>
              <b>Referrals :</b>
              <a href="mailto: founders@fiifi.co">founders@fiifi.co</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      center
      width="400px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="deleteFlag"
    >
      <div class="row" style="padding-left: 15px; padding-right: 15px">
        <div style="margin-left: auto; margin-right: auto">
          Are you sure you want to continue?
        </div>
      </div>
      <div class="col-12 d-flex">
        <div
          class="col-xl edit-company-action-button-row"
          style="padding-right: 25px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelDelete"
            :disabled="isDisabled"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="clearUser"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="isDisabled"
          >
            Continue
            <b-spinner
              v-if="showSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import api from "../../../../axios_api";
import config from "../../../../../config/settings";
import NotificationSample from "../../Components/NotificationSample";
import { Select, Option, Dialog } from "element-ui";
import { TabulatorCard } from "src/components/index";
export default {
  computed: {
    ...mapGetters("user", ["user"]),
    account_role() {
      return this.$store.getters["role/account_role"];
    },
    current_role() {
      return this.$store.getters["role/current_role"];
    },
  },
  data() {
    return {
      invite: {},
      valid: false,
      submitted: false,
      currentRoleId: "",
      facebook: false,
      twitter: false,
      google: false,
      linkedin: false,
      updateCheck: false,
      userProfile: {},
      inviteForm: {},
      pswd: {},
      type: "",
      variant: "",
      navLink: "account",
      message: "",
      roles: ["Admin", "Manager", "collaborator"],
      deleteFlag: false,
      isDisabled: false,
      showSpinner: false,
      dailyCheckbox: false,
      weeklyCheckbox: false,
      monthlyCheckbox: false,
    };
  },
  components: {
    NotificationSample,
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    TabulatorCard,
  },
  methods: {
    userCleared() {
      window.localStorage.clear();
      window.sessionStorage.clear();
      this.$store.commit("user/initialize");
      this.$store.commit("portfolio/initialize");
      this.$store.commit("role/initialize");
      this.$store.commit("team/initialize");
      this.$store.commit("investment/initialize");
      this.$store.commit("offering/initialize");
      this.$store.commit("todo/initialize");
      this.$store.commit("file/initialize");
      this.$store.commit("workspace/initialize");
      this.$store.commit("diligence/initialize");
      this.$store.commit("diligence_stage/initialize");
      this.$store.commit("transaction_type/initialize");
      this.$store.commit("newsFeed/initialize");
      this.$store.commit("suggestions/initialize");
      this.$store.commit("workspacePlans/initialize");
      this.$store.commit("accountPlans/initialize");
      this.$store.commit("contacts/initialize");
      this.$store.commit("lpAllocations/initialize");
      this.$store.commit("dashboardCoordinates/initialize");
      this.$store.commit("rounds/initialize");
      this.$router.push("#/login");
    },
    passwordValidation() {
      let data = this.checkPassword(this.pswd.newPswd);
      if (data) this.valid = true;
      else this.valid = false;
    },
    checkPassword(str) {
      var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,}$/;
      return re.test(str);
    },
    changePswd(e) {
      e.preventDefault();
      if (this.pswd.newPswd == this.pswd.cnfrmPswd) {
        this.submitted = true;
        this.$Amplify.Auth.currentAuthenticatedUser()
          .then((user) => {
            console.log(user);
            this.$Amplify.Auth.changePassword(
              user,
              this.pswd.oldPswd,
              this.pswd.newPswd
            )
              .then((response) => {
                this.$toaster.success(
                  "Password has been changed successfully."
                );
                this.submitted = false;
                this.$router.push("/login");
              })
              .catch((error) => {
                this.variant = "danger";
                this.$toaster.error("Please enter valid Password.");
                // this.$router.push("/login");
                this.submitted = false;
              });
          })
          .catch((err) => {
            this.variant = "danger";
            this.$toaster.error("Unable to process your request.");
            this.$router.push("/login");
            this.submitted = false;
          });
      } else {
        this.variant = "danger";
        this.$toaster.error("Password does not match..!");
      }
    },
    switchRole(item) {
      let curentObj = this.account_role.find((obj) => obj._id == item);
      this.$store.commit("role/setCurrentRole", { current_role: curentObj });
      this.$store.dispatch("portfolio/apiFetchPortfolio").then((res) => {
        if (!this.$store.getters["portfolio/portfolioData"])
          this.$store.commit("portfolio/markData", {
            hasData: false,
          });
      });
    },
    Link(type, check) {
      this.type = type;
      if (type == "linkedin") {
        if (this.user.linkedin && this.user.linkedin.id) {
          this.updateUser("/linkedin/update/profile", false);
        } else {
          window.localStorage.setItem("updateProfile", true);
          window.location.href = `//${config.URL}/api/auth/update/linkedin`;
        }
      } else if (type == "google") {
        if (this.user.google && this.user.google.id) {
          this.updateUser("/google/update/profile", false);
        } else {
          window.localStorage.setItem("updateProfile", true);
          window.location.href = `//${config.URL}/api/auth/update/google`;
        }
      } else if (type == "facebook") {
        if (this.user.facebook && this.user.facebook.id) {
          this.updateUser("/facebook/update/profile", false);
        } else {
          window.localStorage.setItem("updateProfile", true);
          window.location.href = `//${config.URL}/api/auth/update/facebook`;
        }
      } else if (type == "twitter") {
        if (this.user.twitter && this.user.twitter.id) {
          this.updateUser("/twitter/update/profile", false);
        } else {
          window.localStorage.setItem("updateProfile", true);
          window.location.href = `//${config.URL}/api/auth/update/twitter`;
        }
      }
    },
    sendInvite(e) {
      e.preventDefault();
      this.submitted = true;
      api
        .post("/send/user/invite", { encrypt: { data: this.invite } })
        .then((data) => {
          this.dialogVisible = false;
          alert("Invitation Link has been sent");
          this.submitted = false;
        })
        .catch((err) => {
          //alert(err.response.data.message);
          this.dialogVisible = false;
          alert("Invitation Link has been sent");
          this.submitted = false;
        });
    },
    clearUser(e) {
      e.preventDefault();
      this.submitted = true;
      this.showSpinner = true;
      this.isDisabled = true;
      this.$store
        .dispatch("user/apiDeleteUser")
        .then((res) => {
          // alert
          this.submitted = false;
          this.handleCancelDelete();
          alert("Successfully removed your data from the server!");
          this.userCleared();
        })
        .catch((err) => {
          // alert('Unable to delete your info at this time (see console for more detail).')
          console.error(`Error deleting user: ${JSON.stringify(err)}`);
          this.userCleared();
        });
    },
    updateUser(url, user) {
      if (!user) {
        let a = Object.values(this.user);
        let count = 0;
        for (let obj of a) if (typeof obj == "object" && obj["id"]) count++;
        if (count == 1) {
          alert("You cannot unlink your primary account");
          return;
        }
      }
      // this.$notify({ component: NotificationSample, timeout: 3000 });
      let payload = {};
      if (user) payload = user;
      else payload = null;
      api
        .put(url, { encrypt: { data: payload } })
        .then((data) => {
          let user = data.data.encrypt.success;
          if ((payload == null) & (this.type.length > 0)) user[this.type] = {};
          this.setStoreUser(user);
        })
        .catch((err) => {
          alert(err.response.data.message);
          this.$router.push(`/${this.$route.params.account_id}/profile`);
        });
    },
    setStoreUser(user) {
      if (user.google)
        this.$store.commit("user/google", { google: user.google });
      if (user.facebook)
        this.$store.commit("user/facebook", { facebook: user.facebook });
      if (user.twitter)
        this.$store.commit("user/twitter", { twitter: user.twitter });
      if (user.linkedin)
        this.$store.commit("user/linkedin", { linkedin: user.linkedin });
      this.$router.push(`/${this.$route.params.account_id}/profile`);
    },
    saveProfile(e) {
      e.preventDefault();
      this.submitted = true;
      if (this.userProfile.cognito && this.userProfile.cognito.user_name) {
        this.userProfile.email = this.userProfile.cognito.email;
        this.userProfile.user_name = this.userProfile.cognito.user_name;
      }
      api
        .patch("/user/profile", { encrypt: { data: this.userProfile } })
        .then((res) => {
          let user = res.data.encrypt.success;
          this.updateCheck = false;
          this.$store.commit("user/first_name", { first_name: user.firstName });
          this.$store.commit("user/last_name", { last_name: user.lastName });
          let fiifiUsers = JSON.parse(window.localStorage.fiifiUsers);
          fiifiUsers.map((item) => {
            if (item._id == user._id) {
              item.firstName = user.firstName;
              item.lastName = user.lastName;
              if (user.cognito && user.cognito.user_name) {
                item.email = user.cognito.email;
                this.$store.commit("user/email", { email: user.cognito.email });
                this.$store.commit("user/cognito", { cognito: user.cognito });
              }
            }
          });
          window.localStorage.setItem("fiifiUsers", JSON.stringify(fiifiUsers));
          this.$toaster.success("Successfully saved.");
          this.submitted = false;
        })
        .catch((err) => {
          this.variant = "danger";
          this.submitted = false;
          this.$toaster.error("Fail to update user information");
        });
    },
    checkSwitch(data) {
      if (data.google && data.google._id) this.google = true;
      if (data.facebook && data.facebook._id) this.facebook = true;
      if (data.twitter && data.twitter._id) this.twitter = true;
      if (data.linkedin && data.linkedin._id) this.linkedin = true;
    },
    handleCancelDelete() {
      this.deleteFlag = false;
      this.isDisabled = false;
      this.showSpinner = false;
    },
    saveProfilekeyUp() {
      this.updateCheck =
        this.userProfile &&
        this.userProfile.firstName &&
        this.userProfile.firstName.length > 0 &&
        this.userProfile.lastName &&
        this.userProfile.lastName.length > 0
          ? true
          : false;
    },
    checkBoxChangeEvent(e) {
      const self = this;
      api
        .patch(`/emailPreferences/${self.$route.params.account_id}`, {
          encrypt: {
            data: {
              isDailySubscribed: self.dailyCheckbox,
              isweeklySubscribed: self.weeklyCheckbox,
              isMonthlySubscribed: self.monthlyCheckbox,
            },
          },
        })
        .then((data) => {
          self.$toaster.success("Email Preferences updated successfully.");
        })
        .catch((error) => {
          console.log("error in updating emailPreferences", error);
        });
    },
    getEmailPreferences() {
      api
        .get(`/emailPreferences/${this.$route.params.account_id}`, {})
        .then((data) => {
          let emailPreferencesData = data.data.encrypt.success;
          if (emailPreferencesData.length > 0) {
            this.dailyCheckbox = emailPreferencesData[0].isDailySubscribed
              ? emailPreferencesData[0].isDailySubscribed
              : false;
            this.weeklyCheckbox = emailPreferencesData[0].isweeklySubscribed
              ? emailPreferencesData[0].isweeklySubscribed
              : false;
            this.monthlyCheckbox = emailPreferencesData[0].isMonthlySubscribed
              ? emailPreferencesData[0].isMonthlySubscribed
              : false;
          }
        })
        .catch((error) => {
          console.log("error in getting emailPreferences", error);
        });
    },
  },
  mounted() {
    this.currentRoleId = this.current_role ? this.current_role._id : false;
    this.checkSwitch(this.user);
    this.userProfile = JSON.parse(
      JSON.stringify(this.$store.getters["user/user"])
    );
    this.userProfile.image =
      this.userProfile.image && this.userProfile.image.length > 0
        ? this.userProfile.image
        : "static/img/Profile.png";
    if (this.$route.params.account_id) {
      this.getEmailPreferences();
    }
    if (this.$route.query.user) {
      if (this.$route.query.type == "google") {
        let user = JSON.parse(window.atob(this.$route.query.user));
        this.updateUser("/google/update/profile", user);
      }
      if (this.$route.query.type == "facebook") {
        let user = JSON.parse(window.atob(this.$route.query.user));
        this.updateUser("/facebook/update/profile", user);
      }
      if (this.$route.query.type == "twitter") {
        let user = JSON.parse(window.atob(this.$route.query.user));
        this.updateUser("/twitter/update/profile", user);
      }
      if (this.$route.query.type == "linkedin") {
        let user = JSON.parse(window.atob(this.$route.query.user));
        this.updateUser("/linkedin/update/profile", user);
      }
      this.$router.push(`/${this.$route.params.account_id}/profile`);
    }
    this.$watch(
      () => {
        return this.user;
      },
      (data) => {
        this.checkSwitch(data);
      }
    );
  },
};
</script>
<style>
.updateLink {
  color: #0097a7;
}
.profile-pic {
  position: relative;
  display: inline-block;
}

.author:hover .edit {
  display: block;
}

.edit {
  padding-top: 7px;
  padding-right: 7px;
  position: absolute;
  right: 0;
  top: 0;
  display: none;
}

.edit a {
  color: #000;
}

.center {
  display: block;
  margin-left: auto;
  margin-top: 10%;
  margin-right: auto;
  margin-bottom: 5%;
  height: 155px;
  border-radius: 50%;
}
.nameCls {
  text-align: center;
  font: Bold 18px/20px Helvetica Neue;
  letter-spacing: 0;
  color: #2e2e2e;
  opacity: 1;
}

.activeItem {
  background: #e9e6ff 0% 0% no-repeat;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  color: #848484;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #000000;
  background-color: #fff;
  border-bottom: 2px solid #5445f3;
  border-top: none;
  border-left: none;
  border-right: none;
  font-family: "custom-helvetica-bold", "roboto";
}

.nav-tabs .nav-item {
  font-size: 15px;
  line-height: 18px;
}

.nav-tabs .nav-link {
  color: #000000;
}

.SaveBtn {
  background: #5445f3 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 20px #5445f367;
  border: 1px solid #5445f3;
  border-radius: 5px;
  opacity: 1;
  width: 20%;
  color: #ffffff;
  height: 38px;
}
.item {
  margin-right: 3%;
}
.swtchTgle {
  margin-top: -1%;
  margin-left: 5%;
}

label {
  color: #000000 !important;
}
ul {
  cursor: pointer;
}
</style>
